import { api } from "../client";
import type { ApiTokenInfo } from "../types";

export const tokensApi = {
  list: () => api<{ error: boolean; tokens: ApiTokenInfo[] }>("user/tokens/list").then((r) => r.tokens ?? []),
  create: (name: string, expiry: string) =>
    api<{ error: boolean; id: number; token: string }>("user/tokens/create", { body: { name, expiry } }),
  revoke: (id: number) => api<{ error: boolean }>("user/tokens/revoke", { body: { id } }),
};
